<template>
  <div class="uptphone">
    <b>输入短信验证码</b>
    <p v-if="mobile">
      验证码已发送至您的手机
      <i>{{ mobile.slice(0, 3) }}&nbsp;{{ mobile.slice(3, 7) }}&nbsp;{{ mobile.slice(7, 11) }}</i>
    </p>
    <div class="codeWrap" v-show="imgCodeWrapFlag">
      <div class="inputWrap">
        <input
          placeholder="图形验证码"
          maxlength="4"
          v-model="imgCodeValue"
          @keyup="imgCodeChange"
        />
        <img
          class="del-btn"
          src="../../assets/images/close.png"
          v-if="imgCodeFlag"
          @click="clearImgCode"
        />
      </div>
      <div class="codeImg" ref="codeImg" @click="getCodeImg">
        <img :src="codeImg" />
      </div>
    </div>
    <security-code v-model="authCode" :code="authCode" :type="typeFa" :number="num"></security-code>
    <p class="countdown sendAgain" v-if="time == 0" @click="sendAgain">重新发送</p>
    <p class="countdown" v-if="time != 0">{{ time }}s后重新发送</p>
  </div>
</template>

<script>
import securityCode from '../common/securityCode'
import { basepath, random_string, formateMobile } from '../../assets/common/js/config'
export default {
  name: 'updatePhone',
  components: {
    securityCode
  },
  data() {
    return {
      authCode: '',
      time: 60,
      typeFa: 'security',
      num: 6,
      mobile: '',
      areaCode: '86',
      imgCodeValue: '',
      imgCodeFlag: false,
      codeImg: '',
      imgCodeWrapFlag: false
    }
  },
  mounted: function () {
    if (sessionStorage.getItem('ckys4_new_mobile')) {
      this.mobile = sessionStorage.getItem('ckys4_new_mobile')
    }

    if (sessionStorage.getItem('ckys4_new_area_code')) {
      this.areaCode = sessionStorage.getItem('ckys4_new_area_code')
    }

    // if (this.$route.query.area) {
    //   this.areaCode = this.$route.query.area
    // }
    this.countdown()
    this.getCodeImg()
  },
  destroyed() {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    if (to.path == '/country') {
      next('/inphone')
    } else {
      next()
    }
  },
  watch: {
    authCode(n) {
      if (n.length == this.num) {
        this.codeClick()
      }
    }
  },
  methods: {
    // 获取图形验证码
    getCodeImg() {
      let width = this.$refs.codeImg.clientWidth
      let height = this.$refs.codeImg.clientHeight
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg = this.$ajax.getValidateCode_URL(
        'sessionid=' + this.timeout + '&width=' + width + '&height=' + height
      )
    },
    // 检测图形验证码-值改变
    imgCodeChange() {
      this.imgCodeFlag = this.imgCodeValue ? true : false
      this.checkInfo()
    },
    // 检测手机号、图形验证码长度
    checkInfo: function () {
      this.passFlag = this.imgCodeValue.length == 4 ? true : false
    },
    clearImgCode() {
      this.imgCodeValue = ''
      this.imgCodeFlag = false
      this.checkInfo()
    },
    code() {
      let code, sessionid, type, area_code, url
      type = 2
      area_code = sessionStorage.getItem('ckys_wap_area_code')

      url =
        this.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        this.mobile +
        '&code=' +
        this.imgCodeValue +
        '&sessionid=' +
        this.timeout +
        '&type=' +
        type +
        '&area_code=' +
        this.areaCode
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.time = 60
          this.countdown()
        } else if (res.data.code == '10011') {
          this.clearImgCode()
          this.getCodeImg()
        }
      })
    },
    checkPhone: function () {
      if (!/[0-9A-Za-z]{4,6}$/.test(this.authCode)) {
        return false
      } else {
        return true
      }
    },
    // 手机验证码校验接口
    codeClick() {
      var url = this.$ajax.smsCodeVerify_URL + '?mobile=' + this.mobile + '&code=' + this.authCode
      var uptUrl = this.$ajax.updateMeMobile_URL
      var data = {
        mobile: this.mobile
      }
      var that = this
      if (that.checkPhone()) {
        that.$customRequestAjax(url).then((res) => {
          if (res.data.code === 200) {
            that.$customRequestAjax.post(uptUrl, data).then((res) => {
              if (res.data.code === 200) {
                that.$toast({
                  message: '手机号更改成功',
                  icon: require('../../assets/images/succ.png')
                })
                sessionStorage.setItem('ckys4_mobile', that.mobile)
                let mobile = formateMobile(that.mobile)
                gio('people.set', 'userContact_ppl', mobile)
                setTimeout(function () {
                  that.$router.replace('/setting')
                }, 500)
              }
            })
          } else {
            that.authCode = ''
          }
        })
      }
    },
    countdown: function () {
      var that = this
      var timer = setInterval(function () {
        that.time--
        if (that.time <= 0) {
          that.time = 0
          if (!that.imgCodeWrapFlag) {
            that.imgCodeWrapFlag = true
          }
          clearInterval(timer)
        }
      }, 1000)
    },
    sendAgain: function () {
      if (!this.passFlag) {
        this.$toast('请先输入图片验证码')
        return
      }
      this.code()
    },
    chooseCountryClick: function () {
      this.$router.replace({
        path: '/country',
        query: {
          type: 'uptphone'
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.uptphone {
  flex: 1;
  background: #fff;
  padding: 0.38rem 0.3rem 0;
  p {
    font-size: 0.14rem;
    color: #888888;
    line-height: 0.22rem;
    i {
      color: #333333;
      font-weight: 400;
      font-style: normal;
    }
  }
  b {
    font-size: 0.29rem;
    font-weight: 400;
    color: #121c32;
    line-height: 0.41rem;
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    .security-code {
      font-size: 0.16rem;
      height: 0.41rem;
      line-height: 0.4rem;
      margin-right: 0.15rem;
      /*border-bottom: 1px solid #5F6274;*/
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -moz-flex;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      img {
        width: 0.16rem;
        height: 0.16rem;
        padding: 0.06rem 0.05rem 0.06rem 0.03rem;
      }
    }
  }
  .countdown {
    font-size: 0.12rem;
    color: #adadad;
    font-style: normal;
    display: block;
    margin-top: 0.19rem;
    &.sendAgain {
      color: #4a90e2;
    }
  }
  .secuCode {
    width: 100%;
    background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -moz-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -o-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -ms-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    border-radius: 0.25rem;
    display: block;
    opacity: 0.39;
    font-size: 0.17rem;
    color: rgba(254, 254, 254, 1);
    line-height: 0.43rem;
    border: none;
    outline: none;
    margin-top: 0.5rem;
    &.gainRed {
      opacity: 1;
    }
  }
  .codeWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.15rem;
    .inputWrap {
      flex: 1 1 0%;
      position: relative;
      border-radius: 0.22rem;
      padding-left: 0.15rem;
      height: 0.44rem;
      line-height: 0.44rem;
      background: #f7f7f7;
      font-size: 0.16rem;
      color: #000;
      input {
        background: none;
        outline: none;
        border: none;
      }
      .del-btn {
        width: 0.13rem;
        height: 0.13rem;
        position: absolute;
        top: 0;
        right: 0;
        margin: 0.15rem 0.09rem;
      }
    }
    .codeImg {
      height: 0.36rem;
      width: 34.5%;
      background: rgb(238, 238, 238);
      margin-left: 0.1rem;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/phone/updatePhoneCode.vue